import TBodyRow from './TBodyRow';
interface IProps {
  moduleData: any;
  isView: boolean;
}

const TBody = ({ moduleData, isView }: IProps) => {
  return (
    <tbody>
      {moduleData?.length > 0 &&
        moduleData?.map((item: any, index: number) => (
          <TBodyRow
            key={`${index}_tablerow`}
            {...{ moduleData, item, index, isView }}
          />
        ))}
    </tbody>
  );
};

export default TBody;
